export default __webpack_public_path__ + "static/media/whatwedo5.da92eae6.jpg";